export const rehash = <FROM,TO>( from:(Record<string,FROM>|undefined), rehasher:((value:FROM,key:string)=>TO) ) : Record<string,TO> => {
    return Object.entries(from||{}).reduce( (to,[key,value])=>{
        to[key] = rehasher(value,key);
        return to;
    },{} as Record<string,TO>);
}

export default rehash;